export { renderTagGroup_unstable as renderTagGroup } from '@fluentui/react-tags';
